import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';

export type PageWrapperProps = {
  children?: JSX.Element | JSX.Element[] | string | number | null;
  className?: string;
};

export const PageWrapper = ({ children, className }: PageWrapperProps) => {
  const [topWindow, setTopWindow] = useState(0);
  const [leftWindow, setLeftWindow] = useState(0);
  const wrapperDiv = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleResize = () => {
      if (wrapperDiv.current) {
        const rect = wrapperDiv.current.getBoundingClientRect();
        setTopWindow(rect.top);
        setLeftWindow(rect.left);
      }
    };
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      ref={wrapperDiv}
      className={clsx('p-6 overflow-y-auto', className)}
      style={{
        height: `calc(100vh - ${topWindow}px)`,
        width: `calc(100vw - ${leftWindow}px)`,
      }}
    >
      {children}
    </div>
  );
};
